import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-hot-toast";
import { Triangle } from "react-loader-spinner";
import OrderManagementService from "../../../Services/QRCodeServices/Order Management/OrderManagementService";
import TableService from "../../../Services/QRCodeServices/TableSerivce/TableService";
import { DownloadBill } from "./DownloadBill";
import { PrintBill } from "./PrintBill";
import { BillContent } from "./BillContent";
import PaymentModal from "./PaymentModal";
import "./OrderMenu.css";
import CancelOrderModal from "../CancelOrderComponent/CancelOrderModal";
import TableSwitch from "../page/TableSwitch";

export const OrderMenu = ({ selectedTable, setSelectedTable }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSwitchModal = () => {
    setIsOpen(!isOpen);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [orgCode, setOrgCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tables, setTables] = useState([]);
  const [additionalDiscount, setAdditionalDiscount] = useState("");
  const [apiOrderedItems, setApiOrderedItems] = useState([]);
  console.log("🚀 ~ OrderMenu ~ apiOrderedItems:", apiOrderedItems);
  const [localOrderedItems, setLocalOrderedItems] = useState([]);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [serviceChargePercentage, setServiceChargePercentage] = useState(0);
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [orderId, setOrderId] = useState(null);
  const [printBillData, setPrintBillData] = useState(null);
  console.log("🚀 ~ OrderMenu ~ printBillData:", printBillData);
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user ? user.user.roles[0] : null;
  const [responseData, setResponseData] = useState();
  const { currentOrder } = useSelector((state) => state.Order);
  const [storeDiscount, setStoreDiscount] = useState(0);
  console.log("🚀 ~ OrderMenu ~ storeDiscount:", storeDiscount);
const [selectedPaymentType, setSelectedPaymentType] = useState(null);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      setOrgCode(parsedUserInfo?.organizationInfo?.orgCode || null);
    }
    fetchTables();
  }, []);

  useEffect(() => {
    if (selectedTable?.id) {
      fetchOrderedItems();
    }
  }, [selectedTable]);

  const fetchTables = async () => {
    try {
      setLoading(true);
      const tablesData = await TableService.getList();
      const updatedArray = tablesData.map((item) => ({
        ...item,
        label: item.identification,
        value: item.id,
      }));
      setTables(updatedArray);
    } catch (error) {
      console.error("Error fetching tables:", error);
      toast.error("Failed to fetch tables");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderedItems = async () => {
    if (!selectedTable?.id) return;

    try {
      setLoading(true);
      const storedData = JSON.parse(localStorage.getItem("orders")) || [];
      const tableOrder = storedData.find(
        (order) => order.tableID === selectedTable.id
      );

      if (tableOrder && tableOrder.items.length > 0) {
        const formattedLocalOrders = tableOrder.items.map((item, index) => ({
          ...item,
          menuOrderDetailId:
            item.menuOrderDetailId || `local_${index}_${item.menuItemId}`,
          source: "Local Storage",
          quantity: item.quantity || 0,
          complimentryQuantity: item.complimentryQuantity || 0,
        }));

        setLocalOrderedItems(formattedLocalOrders);
      } else {
        setLocalOrderedItems([]);
      }

      const tableData = await TableService.getActiveTableDetail({
        tableId: selectedTable?.id,
      });
      console.log("🚀 ~ fetchOrderedItems ~ tableData:", tableData);

      if (tableData?.menuOrder?.menuOrderDetails) {
        setOrderId(tableData.menuOrder.id);

        const formattedApiOrders = tableData.menuOrder.menuOrderDetails.map(
          (item) => {
            console.log("🚀 ~ fetchOrderedItems ~ item:", item);
            return {
              finalAmount: tableData?.menuOrder?.finalAmount,
              itemAmount: tableData?.menuOrder?.itemAmount,
              itemPrice: item?.itemPrice,
              taxAmount: tableData?.menuOrder?.taxAmount,
              serviceCharge: tableData?.menuOrder?.serviceCharge,
              taxPercentage: tableData?.menuOrder?.taxPercentage,
              discountAmount: tableData?.menuOrder?.discountAmount,
              menuOrderDetailId:
                item.menuOrderDetailId || `api_${item.menuItemId}`,
              menuItemId: item.menuItemDetail?.id || item.menuItemId,
              title: item.menuItemDetail?.title || "Unknown Item",
              price: item.price || item.menuItemDetail?.price || 0,
              quantity: item.quantity || 0,
              complimentryQuantity: item.complimentryQuantity || 0,
              totalPrice: item.totalPrice || 0,
              discountDetail: item.menuItemDetail?.discountDetail || {
                discountPercentage: 0,
              },
              cloudR2ImagePath: item.menuItemDetail?.cloudR2ImagePath || null,
              fullUrl: item.menuItemDetail?.fullUrl || null,
              source: "API",
            };
          }
        );
        console.log(
          "🚀 ~ fetchOrderedItems ~ formattedApiOrders:",
          formattedApiOrders
        );
        setApiOrderedItems(formattedApiOrders);
        const { serviceChargePercentage, taxPercentage } = tableData.menuOrder;
        setServiceChargePercentage(serviceChargePercentage || 0);
        setTaxPercentage(taxPercentage || 0);
      } else {
        setApiOrderedItems([]);
        setOrderId(null);
      }
    } catch (error) {
      console.error("Error fetching ordered items:", error);
      toast.error("Failed to fetch ordered items");
    } finally {
      setLoading(false);
    }
  };

  const handleTableSelect = async (selected) => {
    try {
      if (selected) {
        const res = await TableService.getActiveTableDetail({
          tableId: selected?.id,
        });
        console.log(res);
        res.label = res.identification;
        delete res?.description;
        delete res?.identification;
        setSelectedTable(res);
      } else {
        setApiOrderedItems([]);
        setLocalOrderedItems([]);
        setOrderId(null);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateLocalStorage = (updatedItems) => {
    let storedData = JSON.parse(localStorage.getItem("orders")) || [];
    const tableIndex = storedData.findIndex(
      (order) => order.tableID === selectedTable.id
    );

    const updatedTableOrder = {
      tableID: selectedTable.id,
      items: updatedItems,
      serviceChargePercentage,
      taxPercentage,
    };

    if (tableIndex !== -1) {
      storedData[tableIndex] = updatedTableOrder;
    } else {
      storedData.push(updatedTableOrder);
    }

    localStorage.setItem("orders", JSON.stringify(storedData));
    fetchOrderedItems();
  };

  const handleIncrement = (item, source) => {
    try {
      const updatedItems =
        source === "Local Storage"
          ? localOrderedItems.map((orderItem) =>
              orderItem.menuOrderDetailId === item.menuOrderDetailId
                ? {
                    ...orderItem,
                    // Increment regular quantity
                    quantity: (orderItem.quantity || 0) + 1,
                    // Recalculate total price based on regular quantity only
                    totalPrice:
                      ((orderItem.quantity || 0) + 1) * orderItem.price,
                  }
                : orderItem
            )
          : apiOrderedItems.map((orderItem) =>
              orderItem.menuOrderDetailId === item.menuOrderDetailId
                ? {
                    ...orderItem,
                    quantity: (orderItem.quantity || 0) + 1,
                    totalPrice:
                      ((orderItem.quantity || 0) + 1) * orderItem.price,
                  }
                : orderItem
            );

      if (source === "Local Storage") {
        setLocalOrderedItems(updatedItems);
        updateLocalStorage(updatedItems);
      } else {
        setApiOrderedItems(updatedItems);
      }
    } catch (error) {
      console.error("Error updating item quantity:", error);
      toast.error("Failed to update item quantity");
    }
  };

  const handleDecrement = (item, source) => {
    // Only allow decrement if regular quantity > 0
    if ((item.quantity || 0) <= 0) return;

    try {
      const updatedItems =
        source === "Local Storage"
          ? localOrderedItems.map((orderItem) =>
              orderItem.menuOrderDetailId === item.menuOrderDetailId
                ? {
                    ...orderItem,
                    quantity: Math.max(0, (orderItem.quantity || 0) - 1),
                    totalPrice:
                      Math.max(0, (orderItem.quantity || 0) - 1) *
                      orderItem.price,
                  }
                : orderItem
            )
          : apiOrderedItems.map((orderItem) =>
              orderItem.menuOrderDetailId === item.menuOrderDetailId
                ? {
                    ...orderItem,
                    quantity: Math.max(0, (orderItem.quantity || 0) - 1),
                    totalPrice:
                      Math.max(0, (orderItem.quantity || 0) - 1) *
                      orderItem.price,
                  }
                : orderItem
            );

      if (source === "Local Storage") {
        setLocalOrderedItems(updatedItems);
        updateLocalStorage(updatedItems);
      } else {
        setApiOrderedItems(updatedItems);
      }
    } catch (error) {
      console.error("Error updating item quantity:", error);
      toast.error("Failed to update item quantity");
    }
  };

  const validateOrder = () => {
    if (!orgCode) {
      toast.error("Organization code not found. Please try logging in again.");
      return false;
    }
    if (localOrderedItems.length === 0 && apiOrderedItems.length === 0) {
      toast.error("Your order is empty.");
      return false;
    }
    if (!selectedTable) {
      toast.error("Please select a table");
      return false;
    }
    return true;
  };

  const handlePlaceOrder = async () => {
    if (!validateOrder()) return;

    setLoading(true);
    try {
      const combinedItems = [...apiOrderedItems, ...localOrderedItems];
      console.log("🚀 ~ handlePlaceOrder ~ combinedItems:", combinedItems);
      const orderPayload = {
        tableId: selectedTable.id,
        items: combinedItems.map((item) => ({
          menuItemId: item.menuItemId,
          quantity: item.quantity || 0,
          price: item.price,
          totalPrice: item.totalPrice || 0,
          complimentryQuantity: item.complimentryQuantity || 0,
          notes: item?.notes || "",
        })),
        serviceChargePercentage,
        taxPercentage,
        additionalDiscount: parseFloat(additionalDiscount) || 0,
      };

      const response = await OrderManagementService.addOrder(
        orgCode,
        orderPayload
      );
      setOrderId(response.id);
      console.log("Order placed successfully:", response);

      let storedData = JSON.parse(localStorage.getItem("orders")) || [];
      storedData = storedData.filter(
        (order) => order.tableID !== selectedTable.id
      );
      localStorage.setItem("orders", JSON.stringify(storedData));

      toast.success("Order placed successfully!");
      await fetchOrderedItems();
      await fetchTables();
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error(
        "Failed to place order: " + (error.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateOrder = async () => {
    if (!orderId || !validateOrder()) return;

    setLoading(true);
    try {
      const combinedItems = [...apiOrderedItems, ...localOrderedItems];
      console.log("🚀 ~ handleUpdateOrder ~ combinedItems:", combinedItems);

      const updatedData = {
        items: combinedItems.map((item) => ({
          menuItemId: item.menuItemId,
          quantity: item.quantity || 0,
          price: item.price,
          complimentryQuantity: item.complimentryQuantity || 0,
          notes: item?.notes || "",
          menuOrderDetailId: isNaN(parseInt(item.menuOrderDetailId))
            ? 0
            : parseInt(item.menuOrderDetailId),
        })),
      };

      const response = await OrderManagementService.update(
        orderId,
        updatedData
      );

      let storedData = JSON.parse(localStorage.getItem("orders")) || [];
      storedData = storedData.filter(
        (order) => order.tableID !== selectedTable.id
      );
      localStorage.setItem("orders", JSON.stringify(storedData));

      toast.success("Order updated successfully!");
      await fetchOrderedItems();
    } catch (error) {
      console.error("Error updating order:", error);
      toast.error(
        "Failed to update order: " + (error.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (item, source) => {
    try {
      if (source === "Local Storage") {
        const updatedItems = localOrderedItems.filter(
          (orderItem) => orderItem.menuOrderDetailId !== item.menuOrderDetailId
        );
        setLocalOrderedItems(updatedItems);
        updateLocalStorage(updatedItems);
      } else {
        setLoading(true);
        const menuOrderDetailId = isNaN(parseInt(item.menuOrderDetailId))
          ? item.menuOrderDetailId
          : parseInt(item.menuOrderDetailId);

        await OrderManagementService.deleteOrderItem(
          orderId,
          menuOrderDetailId
        );

        const updatedItems = apiOrderedItems.filter(
          (orderItem) => orderItem.menuOrderDetailId !== item.menuOrderDetailId
        );
        setApiOrderedItems(updatedItems);
        await fetchOrderedItems();
      }
      toast.success("Item removed successfully");
    } catch (error) {
      console.error("Error removing item:", error);
      toast.error(
        "Failed to remove item: " + (error.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancelOrder = async () => {
    console.log(orderId);
    console.log(localOrderedItems);
    if (orderId) {
      setLoading(true);
      try {
        await OrderManagementService.cancelTable(orderId, 3);
        toast.success("Order cancelled successfully!");
        setOrderId(null);
        await fetchOrderedItems();
        await fetchTables();
      } catch (error) {
        console.error("Error cancelling order:", error);
        toast.error(
          "Failed to cancel order: " + (error.message || "Unknown error")
        );
      } finally {
        setLoading(false);
      }
    } else {
      let storedData = JSON.parse(localStorage.getItem("orders")) || [];
      storedData = storedData.filter(
        (order) => order.tableID !== selectedTable.id
      );
      localStorage.setItem("orders", JSON.stringify(storedData));
      setLocalOrderedItems([]);
      toast.success("Local order cleared successfully!");
    }
    setIsCancelModalOpen(false);
  };

  const handleDiscountChange = (e) => {
    const value = e.target.value;
    if (
      value === "" ||
      (/^\d*\.?\d*$/.test(value) && parseFloat(value) <= 100)
    ) {
      setAdditionalDiscount(value);
    }
  };

  // Calculate total amount before discount - only from regular quantities
  const calculateTotalAmountBeforeDiscount = (items) => {
    console.log("🚀 ~ calculateTotalAmountBeforeDiscount ~ items:", items);
    return items.reduce((total, item) => {
      console.log("🚀 ~ calculateTotalAmountBeforeDiscount ~ item:", item);
      // Only calculate for regular quantity, not complementary
      return total + (item.price || 0) * (item.quantity || 0);
    }, 0);
  };

  const calculateTotalDiscount = (items, subtotalAmount) => {
    const itemDiscounts = items.reduce((total, item) => {
      // Only apply discounts to regular quantities
      const regularTotal = (item.price || 0) * (item.quantity || 0);
      const discountPercentage = item.discountDetail?.discountPercentage || 0;
      return total + regularTotal * (discountPercentage / 100);
    }, 0);

    const additionalDiscountAmount =
      additionalDiscount && !isNaN(parseFloat(additionalDiscount))
        ? subtotalAmount * (parseFloat(additionalDiscount) / 100)
        : 0;

    return itemDiscounts + additionalDiscountAmount;
  };

  const combinedItems = [...apiOrderedItems, ...localOrderedItems];
  const subtotalAmount = calculateTotalAmountBeforeDiscount(combinedItems);
  const totalDiscount = calculateTotalDiscount(combinedItems, subtotalAmount);
  const discountAmount = (subtotalAmount * storeDiscount) / 100;

  const finalAmountBeforeTaxAndService = Math.max(
    0,
    subtotalAmount - discountAmount
  );

  const serviceCharge =
    (finalAmountBeforeTaxAndService * serviceChargePercentage) / 100;
  const taxAmount = (finalAmountBeforeTaxAndService * taxPercentage) / 100;
  const netAmount = finalAmountBeforeTaxAndService;
  console.log("🚀 ~ OrderMenu ~ netAmount:", netAmount);

  const handlePaymentSubmit = async (paymentData) => {
    console.log("🚀 ~ handlePaymentSubmit ~ paymentData:", paymentData);
    setPaymentLoading(true);
    try {
      const currentTable = await TableService.getActiveTableDetail({
        tableId: selectedTable?.id,
      });

      if (!currentTable?.menuOrder?.id) {
        throw new Error("Order ID not found");
      }

      const paymentPayload = {
        addDiscount: paymentData?.addDiscount || 0,
        type: parseInt(paymentData.type),
        name: paymentData.name.trim(),
        phoneNumber: paymentData.phoneNumber.trim(),
        address: paymentData.address.trim(),
        remarks: paymentData.remarks.trim(),
        BankId: paymentData.BankId,
        customerId: paymentData?.customerId,
        ...(parseInt(paymentData.type) === 5 && {
          paidAmount: paymentData.paidAmount,
          paymentMethod: paymentData.paymentMethod ?? 0,
          menuOrderId: paymentData.menuOrderId,
          totalBillAmount: paymentData.totalBillAmount,
        }),
      };

      console.log(paymentData);

      const response = await OrderManagementService.processBillingPayment(
        currentTable.menuOrder.id,
        paymentPayload
      );
      console.log("🚀 ~ handlePaymentSubmit ~ response:", response);
      setResponseData(response);

      if (paymentData.printBill) {
        setPrintBillData({
          name: paymentData.name.trim(),
          phoneNumber: paymentData.phoneNumber.trim(),
          address: paymentData.address.trim(),
          remarks: paymentData.remarks.trim(),
          paymentType: parseInt(paymentData.type),
          addDiscount: paymentData?.addDiscount || 0,
        });
        setIsModalOpen(true);
      } else {
        setPrintBillData(null);
      }

      let storedData = JSON.parse(localStorage.getItem("orders")) || [];
      storedData = storedData.filter(
        (order) => order.tableID !== selectedTable.id
      );
      localStorage.setItem("orders", JSON.stringify(storedData));

      toast.success("Payment processed successfully!");
      setIsPaymentModalOpen(false);

      if (!paymentData.printBill) {
        setSelectedTable(null);
        setAdditionalDiscount("");
        setApiOrderedItems([]);
        setLocalOrderedItems([]);
        setOrderId(null);
        await fetchTables();
      }
      // setStoreDiscount(null);
    } catch (error) {
      console.error("Error processing payment:", error);
      toast.error(error.message || "Failed to process payment");
    } finally {
      setPaymentLoading(false);
    }
  };

  const renderItems = (items, source) =>
    items.map((item) => {
      console.log("🚀 ~ renderItems ~ item:", item);

      const regularQuantity = item.quantity || 0;
      const complementaryQuantity = item.complimentryQuantity || 0;
      const totalQuantityDisplay = regularQuantity;

      // Determine pricing display logic
      let priceDisplay,
        totalPriceDisplay,
        showComplementaryInfo = false;

      if (regularQuantity > 0 && complementaryQuantity > 0) {
        // Both regular and complementary - show price for regular quantity
        priceDisplay = item.price || 0;
        totalPriceDisplay = item.totalPrice || 0;
        showComplementaryInfo = true;
      } else if (regularQuantity > 0 && complementaryQuantity === 0) {
        // Only regular quantity - show normal pricing
        priceDisplay = item.price || 0;
        totalPriceDisplay = item.totalPrice || 0;
      } else if (regularQuantity === 0 && complementaryQuantity > 0) {
        // Only complementary - show as free
        priceDisplay = 0;
        totalPriceDisplay = 0;
        showComplementaryInfo = true;
      } else {
        // No quantity - shouldn't normally happen
        priceDisplay = 0;
        totalPriceDisplay = 0;
      }

      const originalPrice = item.price || 0;
      const discountPercentage = item.discountDetail?.discountPercentage || 0;
      const discountAmount = originalPrice * (discountPercentage / 100);
      const discountedPrice = Math.max(0, originalPrice - discountAmount);

      return (
        <div
          key={item.menuOrderDetailId}
          className="card m-0 p-0 border-0 shadow-sm mb-3"
        >
          <div className="card-body p-2">
            <div className="d-flex align-items-center gap-3">
              <div className="order-menu-image flex-shrink-0">
                <img
                  src={
                    (typeof item.imageUrl === "string" && item.imageUrl) ||
                    (item.cloudR2ImagePath &&
                    typeof item.cloudR2ImagePath.getCDNUrl === "function"
                      ? item.cloudR2ImagePath.getCDNUrl()
                      : item.cloudR2ImagePath) ||
                    "https://via.placeholder.com/150"
                  }
                  alt={item.title}
                  className="rounded"
                />
              </div>
              <div className="flex-grow-1">
                <div className="mb-2">
                  <h5 className="mb-1">
                    {item.title}
                    {showComplementaryInfo && (
                      // <span className="badge bg-info ms-2">
                      //   {regularQuantity > 0 && complementaryQuantity > 0
                      //     ? `Mixed: ${regularQuantity} Paid + ${complementaryQuantity} Free`
                      //     : "Complementary"}
                      // </span>
                      <span className="badge text-black  ms-2">
                        {regularQuantity > 0 && complementaryQuantity > 0 ? (
                          <>🎁 {complementaryQuantity}</>
                        ) : (
                          <strong>🎁 {complementaryQuantity}</strong>
                        )}
                      </span>
                    )}
                  </h5>
                  <div className="d-flex flex-wrap gap-2">
                    {/* Price */}
                    {!(regularQuantity === 0 && complementaryQuantity > 0) && (
                      <p className="text-success fw-medium m-0 p-0">
                        Rs. {discountedPrice.toFixed(2)}
                      </p>
                    )}

                    {/* Original price with discount */}
                    {regularQuantity > 0 && discountPercentage > 0 && (
                      <p className="text-muted mb-0">
                        <del>Rs. {originalPrice.toFixed(2)}</del> (
                        {discountPercentage}% OFF)
                      </p>
                    )}

                    {/* Total */}
                    {!(regularQuantity === 0 && complementaryQuantity > 0) && (
                      <p className="text-muted mb-0">
                        Total: Rs. {item?.totalPrice?.toFixed(2)}
                      </p>
                    )}

                    {/* Complementary Info (optional: uncomment if needed) */}
                    {/* 
  {showComplementaryInfo &&
    regularQuantity > 0 &&
    complementaryQuantity > 0 && (
      <span className="text-info ms-1">
        + {complementaryQuantity} free
      </span>
    )
  } 
  */}
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  {!(regularQuantity === 0 && complementaryQuantity > 0) && (
                    <div className="btn-group quantity-controls">
                      <Button
                        size="sm"
                        outline
                        onClick={() => handleDecrement(item, source)}
                        disabled={regularQuantity <= 0}
                      >
                        -
                      </Button>
                      <Button size="sm" outline className="px-3 disabled">
                        {totalQuantityDisplay}
                        {/* {showComplementaryInfo && (
                        <small className="text-muted ms-1">
                          ({regularQuantity}+{complementaryQuantity})
                        </small>
                      )} */}
                      </Button>
                      <Button
                        size="sm"
                        outline
                        onClick={() => handleIncrement(item, source)}
                      >
                        +
                      </Button>
                    </div>
                  )}
                  <div className="w-100 d-flex justify-content-end">
                    <Button
                      color="danger"
                      size="sm"
                      outline
                      className="d-flex align-items-center gap-1 "
                      onClick={() => handleRemove(item, source)}
                    >
                      <i className="ri-delete-bin-line"></i>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

  useEffect(() => {
    if (!isModalOpen) {
      setSelectedTable(null);
      setAdditionalDiscount("");
      setApiOrderedItems([]);
      setLocalOrderedItems([]);
      setOrderId(null);
      fetchTables();
    }
  }, [isModalOpen]);
  return (
    <div
      className="mb-3"
      style={{ display: "flex", flexDirection: "column", height: "100vh" }}
    >
      <Row className="mb-2 sticky-top " style={{ zIndex: 1 }}>
        {/* Customer Contact */}
        <Col lg={6} md={12} sm={12} className="mb-2 mb-lg-0">
          <input
            type="text"
            className="form-control"
            placeholder="Customer Contact"
            required
          />
        </Col>

        {/* Table Select + Switch button */}
        <Col lg={6} md={12} sm={12}>
          <Row className="g-2 align-items-center">
            <Col xs={10}>
              <Select
                options={tables}
                value={selectedTable}
                onChange={handleTableSelect}
                placeholder="Select Table"
                isClearable
                className="table-select w-100"
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    color: state.data.isOccupied ? "red" : "black",
                    cursor: "pointer",
                  }),
                  control: (provided) => ({
                    ...provided,
                    borderColor: selectedTable?.isOccupied
                      ? "red"
                      : provided.borderColor,
                    boxShadow: "none",
                    "&:hover": {
                      borderColor: selectedTable?.isOccupied
                        ? "red"
                        : provided.borderColor,
                    },
                  }),
                }}
              />
            </Col>
            <Col xs={2} className="">
              <div className="d-flex">
                <button
                  className="btn btn-success btn-sm"
                  onClick={toggleSwitchModal}
                  disabled={!selectedTable?.id}
                >
                  <i className="bx bx-repost"></i>
                </button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <Triangle
            visible={true}
            height="80"
            width="80"
            color="#5B71B9"
            ariaLabel="triangle-loading"
          />
        </div>
      )}

      {!loading && (
        <div className="ordered-items-section">
          <h6>Ordered Items</h6>
          {combinedItems.length > 0 ? (
            <>
              {renderItems(apiOrderedItems, "API")}
              {renderItems(localOrderedItems, "Local Storage")}
            </>
          ) : (
            <div className="text-center p-4 d-flex flex-column align-items-center justify-content-center">
              <div className="d-flex justify-content-center align-items-center p-2 bg-white rounded-sm">
                <i className="ri-restaurant-line fs-3"></i>
              </div>
              <p className="text-muted mb-0">No ordered items for this table</p>
            </div>
          )}
        </div>
      )}

      <div className="card border-0 order-pos-bottom shadow-sm p-3">
        <div className="d-flex justify-content-between align-items-center mb-2 gap-2">
          {!orderId ? (
            <Button
              color="primary"
              className="btn-sm rounded-4 flex-grow-1"
              style={{ height: "30px" }}
              onClick={handlePlaceOrder}
              disabled={loading || combinedItems.length === 0}
            >
              {loading ? (
                <span>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Placing Order...
                </span>
              ) : (
                "Place Order"
              )}
            </Button>
          ) : (
            <Button
              color="primary"
              className="btn-sm rounded-4 flex-grow-1"
              style={{ height: "30px" }}
              onClick={handleUpdateOrder}
              disabled={loading || combinedItems.length === 0}
            >
              {loading ? (
                <span>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Updating Order...
                </span>
              ) : (
                "Update Order"
              )}
            </Button>
          )}
          <Button
            color="danger"
            className="btn-sm rounded-4 d-flex align-items-center justify-content-center"
            style={{ height: "30px", width: "30px" }}
            onClick={() => setIsCancelModalOpen(true)}
            disabled={loading || (localOrderedItems.length === 0 && !orderId)}
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              <i
                className="ri-delete-bin-line"
                style={{ fontSize: "16px" }}
              ></i>
            )}
          </Button>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <p className="mb-0 fw-bold">Net Amount:</p>
          <p className="mb-0 fw-bold text-success">
            Rs. {netAmount.toFixed(2)}
          </p>
        </div>
        {role !== "Waiter" && (
          <div className="d-flex justify-content-between gap-2">
            <Button
              className="w-100 btn-sm"
              color="secondary"
              onClick={() => setIsModalOpen(true)}
              disabled={combinedItems.length === 0}
            >
              View Bill
            </Button>
            <Button
              color="primary"
              className="w-100 btn-sm"
              onClick={() => setIsPaymentModalOpen(true)}
              disabled={loading || combinedItems.length === 0}
            >
              {loading ? (
                <span>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Processing...
                </span>
              ) : (
                "Pay Now"
              )}
            </Button>
          </div>
        )}
      </div>

      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        size="md"
      >
        <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)} />
        <ModalBody>
          <BillContent
            currentOrder={combinedItems}
            totalAmountBeforeDiscount={subtotalAmount}
            totalDiscount={totalDiscount}
            serviceCharge={serviceCharge}
            taxAmount={taxAmount}
            netAmount={netAmount}
            responseData={responseData}
            taxPercentage={taxPercentage}
            apiOrderedItems={apiOrderedItems}
            printBillData={printBillData}
            storeDiscount={storeDiscount}
            discountAmount={discountAmount}
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <Button color="danger" outline onClick={() => setIsModalOpen(false)}>
            Close
          </Button>
          <div className="d-flex gap-3">
            <DownloadBill
              currentOrder={combinedItems}
              totalAmountBeforeDiscount={subtotalAmount}
              totalDiscount={totalDiscount}
              serviceCharge={serviceCharge}
              taxAmount={taxAmount}
              netAmount={netAmount}
              responseData={responseData}
              discountAmount={discountAmount}
            />
            <PrintBill
              currentOrder={combinedItems}
              totalAmountBeforeDiscount={subtotalAmount}
              totalDiscount={totalDiscount}
              serviceCharge={serviceCharge}
              taxAmount={taxAmount}
              netAmount={netAmount}
              customerData={printBillData}
              responseData={responseData}
              apiOrderedItems={apiOrderedItems}
              discountAmount={discountAmount}
              selectedPaymentType={selectedPaymentType}
              selectedTable={selectedTable}
            />
          </div>
        </ModalFooter>
      </Modal>

      <PaymentModal
        isOpen={isPaymentModalOpen}
        toggle={() => setIsPaymentModalOpen(!isPaymentModalOpen)}
        onSubmit={handlePaymentSubmit}
        loading={paymentLoading}
        orderId={orderId}
        netAmount={netAmount.toFixed(2)}
        fetchTable={fetchTables}
        setStoreDiscount={setStoreDiscount}
        setSelectedPaymentType={setSelectedPaymentType}
        selectedPaymentType={selectedPaymentType}
      />
      <CancelOrderModal // Include the cancel modal component
        isOpen={isCancelModalOpen}
        toggle={() => setIsCancelModalOpen(!isCancelModalOpen)}
        onConfirm={handleCancelOrder}
      />
      <TableSwitch
        isOpen={isOpen}
        toggle={toggleSwitchModal}
        initialTable={selectedTable}
        fetchOrderedItems={fetchOrderedItems}
        fetchTables={fetchTables}
        orderId={orderId}
      />
    </div>
  );
};
